// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-browse-section {
  margin-top: 100px; /* Leave space below header */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px; /* Space between sections */
}

.step-and-instruction {
  display: flex;
  align-items: center;
  gap: 15px; /* Space between step circle and text */
}

.step-number {
  background-color: #0056FF; /* Blue color */
  color: white;
  font-size: 24px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  margin: 0;
  font-size: 20px;
}

.file-input-container {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 90%; /* Make wider and more responsive */
  max-width: 800px; /* Maximum width */
  gap: 10px; /* Space between button and text */
  background-color: #f9f9f9;
  padding: 12px 15px; /* More padding for inner elements */
}

.file-selection-row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap; /* Allow wrapping if not enough space */
  gap: 10px; /* Space between items */
}

.file-browse-button {
  padding: 10px 15px;
  margin-right: 10px;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.file-browse-button:hover {
  background-color: #3367d6;
}

.demo-file-button {
  padding: 10px 15px;
  background-color: #34a853;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
  margin-right: 20px;
}

.demo-file-button:hover {
  background-color: #2e8644;
}

.demo-file-button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.demo-file-button .spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spinner 1s ease-in-out infinite;
  vertical-align: middle;
}

#file-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #555;
  font-size: 0.95rem;
  max-width: 300px; /* Limit max width */
  display: inline-block; /* Behave like block for truncation */
  vertical-align: middle; /* Align with buttons */
  margin-left: 8px; /* Space from buttons */
}

.format-instructions-row {
  width: 100%;
  padding-left: 2px;
}

/* Input Format Instructions Link */
.format-instructions-link {
  display: inline-block;
  font-size: 0.9rem;
  color: #1a73e8;
  text-decoration: none;
  margin: 4px 0;
  transition: color 0.2s;
}

.format-instructions-link:hover {
  color: #174ea6;
  text-decoration: underline;
}

.file-input-hidden {
  display: none; /* Hidden file input */
}`, "",{"version":3,"sources":["webpack://./src/css/step1-browseFile.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE,6BAA6B;EAChD,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS,EAAE,2BAA2B;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,uCAAuC;AACpD;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU,EAAE,mCAAmC;EAC/C,gBAAgB,EAAE,kBAAkB;EACpC,SAAS,EAAE,kCAAkC;EAC7C,yBAAyB;EACzB,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe,EAAE,uCAAuC;EACxD,SAAS,EAAE,wBAAwB;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB,EAAE,oBAAoB;EACtC,qBAAqB,EAAE,qCAAqC;EAC5D,sBAAsB,EAAE,uBAAuB;EAC/C,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC","sourcesContent":[".file-browse-section {\n  margin-top: 100px; /* Leave space below header */\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px; /* Space between sections */\n}\n\n.step-and-instruction {\n  display: flex;\n  align-items: center;\n  gap: 15px; /* Space between step circle and text */\n}\n\n.step-number {\n  background-color: #0056FF; /* Blue color */\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  margin: 0;\n  font-size: 20px;\n}\n\n.file-input-container {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 90%; /* Make wider and more responsive */\n  max-width: 800px; /* Maximum width */\n  gap: 10px; /* Space between button and text */\n  background-color: #f9f9f9;\n  padding: 12px 15px; /* More padding for inner elements */\n}\n\n.file-selection-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex-wrap: wrap; /* Allow wrapping if not enough space */\n  gap: 10px; /* Space between items */\n}\n\n.file-browse-button {\n  padding: 10px 15px;\n  margin-right: 10px;\n  background-color: #4285f4;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s;\n}\n\n.file-browse-button:hover {\n  background-color: #3367d6;\n}\n\n.demo-file-button {\n  padding: 10px 15px;\n  background-color: #34a853;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s;\n  margin-right: 20px;\n}\n\n.demo-file-button:hover {\n  background-color: #2e8644;\n}\n\n.demo-file-button:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.demo-file-button .spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spinner 1s ease-in-out infinite;\n  vertical-align: middle;\n}\n\n#file-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #555;\n  font-size: 0.95rem;\n  max-width: 300px; /* Limit max width */\n  display: inline-block; /* Behave like block for truncation */\n  vertical-align: middle; /* Align with buttons */\n  margin-left: 8px; /* Space from buttons */\n}\n\n.format-instructions-row {\n  width: 100%;\n  padding-left: 2px;\n}\n\n/* Input Format Instructions Link */\n.format-instructions-link {\n  display: inline-block;\n  font-size: 0.9rem;\n  color: #1a73e8;\n  text-decoration: none;\n  margin: 4px 0;\n  transition: color 0.2s;\n}\n\n.format-instructions-link:hover {\n  color: #174ea6;\n  text-decoration: underline;\n}\n\n.file-input-hidden {\n  display: none; /* Hidden file input */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
